import React from 'react'

type Props = { children: React.ReactNode | React.ReactNode[], className?: string, fullHeight?: boolean }
const Card: React.FC<Props> = ({ children, className, fullHeight = true }) => {
  return (
    <div className={`${fullHeight ? 'h-full' : ''} px-3 py-2.5 sm:inline-block rounded-lg ${className}`}>
      {children}
    </div>
  )
}

export default Card
